// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nQYW","title":"styles_title__38w3F"};